import React from "react";
import { useFela } from "react-fela";

import { Grid } from "@/components/Grid";
import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import { Image } from "@/components/Image";
import { StyledIconWrapper, Icon } from "@/components/Icon";

import { IConvertAllFormatsSection } from "./types";

type IProps = IConvertAllFormatsSection & JSX.IntrinsicElements["div"];

export const ConvertAllFormatsSection: React.FC<IProps> = ({
  elements,
  ...rest
}) => {
  const { css } = useFela();
  const { colors, bp } = useTheme();

  return (
    <>
      <Grid
        id="ConvertAllFormatsSection#1"
        customStyle={{
          flexDirection: "column",
          alignItems: "center",
          [bp.FROM_DESKTOP]: {
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
          },
        }}
        wrapperStyle={{ backgroundColor: colors.LIGHT_GRAY2 }}
        {...rest}
      >
        {elements.map(({ id, title, subtitle, image: { src, alt } }, index) => {
          return (
            <div
              className={css({
                order: (index !== 0 && 1) || 0,
                [bp.FROM_DESKTOP]: {
                  width: "50%",
                },
              })}
              key={id}
            >
              <div className={css({ [bp.FROM_DESKTOP]: { minHeight: 92 } })}>
                <Heading as="h2">{title}</Heading>
              </div>

              <p
                className={css({
                  marginBottom: 30,
                  marginTop: 15,
                  fontSize: 18,
                  lineHeight: "28px",
                  letterSpacing: 0.5,
                  color: colors.GRAY,
                  nested: {
                    "> strong": {
                      color: colors.SKY_BLUE,
                    },
                  },
                  [bp.FROM_DESKTOP]: {
                    marginTop: 30,
                    marginBottom: 60,
                    minHeight: 52,
                  },
                })}
              >
                {subtitle}
              </p>
              <Image
                src={src}
                alt={alt}
                customStyle={{
                  width: "100%",
                  borderRadius: 8,
                  boxShadow: `12px 8px 20px 0 ${colors.CETACEAN_BLUE}`,
                }}
              />
            </div>
          );
        })}
        <StyledIconWrapper
          wrapperStyle={{
            width: 60,
            height: 60,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: 30,
            borderRadius: "50%",
            backgroundColor: colors.WHITE,
            boxShadow: `12px 8px 20px 0 ${colors.CETACEAN_BLUE}`,
            transform: "rotate(90deg)",
            [bp.FROM_DESKTOP]: {
              marginTop: 30,
              alignSelf: "center",
              flexShrink: 0,
              transform: "none",
            },
          }}
        >
          <Icon iconType="ARROW-RIGHT-GREY" />
        </StyledIconWrapper>
      </Grid>
    </>
  );
};
